import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {updateImageUrl} from "../../tools/func";

function Avatar({url}:{url: string}) {
    return (
        <div className="col-auto">
            <img alt={""} src={updateImageUrl(url, {width: 160, height:160})} style={{
                objectFit:'cover',
                height: 80,
                width: 80,
            }} className={"rounded-circle"}/>
        </div>
    );
}

export default Avatar;
